"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOverviewLink = exports.backToOverviewLink = void 0;
exports.fetchPhrases = fetchPhrases;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _phrase = require("@insided/deprecated-libs/translationsUtils/phrase");

function fetchPhrases(_x) {
  return _fetchPhrases.apply(this, arguments);
}

function _fetchPhrases() {
  _fetchPhrases = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(phrasesSet) {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all(phrasesSet.map( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(p) {
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return new Promise(function (resolve) {
                          return (0, _phrase.fetchPhrase)(p.module, p.key, function (phrs) {
                            return resolve(phrs);
                          });
                        });

                      case 2:
                        return _context.abrupt("return", _context.sent);

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref.apply(this, arguments);
              };
            }()));

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchPhrases.apply(this, arguments);
}

var defaultOverviewLink = {
  name: 'Back to Overview',
  link: '/overview'
};
exports.defaultOverviewLink = defaultOverviewLink;
var backToOverviewLink = {
  idea: {
    name: 'Ideas overview',
    link: '/idea/overview'
  },
  productUpdate: {
    name: 'Product updates overview',
    link: '/product-update/overview'
  },
  question: defaultOverviewLink,
  conversation: defaultOverviewLink,
  article: {
    name: 'Articles Overview',
    link: '/article/overview'
  }
};
exports.backToOverviewLink = backToOverviewLink;